/* eslint-disable operator-linebreak */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-param-reassign */
/* eslint-disable import/no-unresolved */
import { useState } from 'react';
import {
  Grid,
  Box,
  Button,
  CircularProgress,
  Typography,
  Stack,
} from '@mui/material';
import { Form, Formik } from 'formik';
import { useSelector } from 'react-redux';
import * as yup from 'yup';
import { selectAuth, selectCart, selectOrder } from '@/store/selectors';
import { validationSchema } from '@/utils/helpers';
import { useFetchFreeTables, useSplitTable } from '@/services/hooks';
import Select from '@/components/Forms/Select';

let initialState: any = {};

const inputBox = {
  position: 'absolute',
  top: '-2px',
  right: '-100px',
  height: '26px',
  width: '41px',
  borderRadius: '8px',
  border: '1px solid #D9D9D9',

  '& input': {
    width: '100%',
    height: '100%',
    borderRadius: '8px',
    border: 'none',
    textAlign: 'center',
    fontFamily: 'inherit',

    '&:focus': {
      outline: 'none',
    },
  },
};

const SplitTableForm = () => {
  const { items } = useSelector(selectCart);
  const { data: freeTables } = useFetchFreeTables();
  const { restaurant_table, current_invoice, customer } =
    useSelector(selectOrder);
  const { cashierId } = useSelector(selectAuth);
  const { mutate, isLoading } = useSplitTable();

  const { dynamic } = validationSchema;

  const cartState = items.reduce((total: any, current) => {
    total[current.item_code] = 0;
    return total;
  }, {});

  initialState = { ...cartState, table: '' };

  const handleSplit = (values: typeof initialState) => {
    // Update the count of the items
    const updatedItemsCount = items.map((item) => {
      const itemsObject = { ...item, qty: values[item.item_code] };

      return itemsObject;
    });

    // Filter out items that qty is equal to zero
    const tableItems = updatedItemsCount?.filter((item) => item.qty !== 0);

    // Get the details of the selected table
    const selectedTable = freeTables?.find(
      (freetable: any) => freetable.name === values.table,
    );

    // Create the split table object
    const splitTableObj = {
      selected_table: selectedTable,
      name: current_invoice,
      owner: cashierId,
      customer,
      restaurant_table,
      items: tableItems,
    };

    return splitTableObj;
  };

  const handleSubmit = (values: typeof initialState) => {
    const splitTableObj = handleSplit(values);

    mutate(splitTableObj);
  };
  return (
    <Box mt={6}>
      <Formik
        initialValues={initialState}
        onSubmit={handleSubmit}
        validationSchema={yup.object({
          table: dynamic('Table'),
        })}
      >
        {(props) => (
          <Form onSubmit={props.handleSubmit}>
            <Grid container columnSpacing={4} rowSpacing={6}>
              <Grid item xs={12}>
                <Box
                  sx={{
                    border: '1px solid #D9D9D9',
                    borderRadius: '20px',
                    backgroundColor: '#fff',
                    width: '100%',
                    maxHeight: '200px',
                    height: '200px',
                    overflow: 'auto',
                  }}
                >
                  <Stack
                    direction="row"
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      mx: 'auto',
                      width: '50%',
                    }}
                  >
                    <Typography>Item</Typography>
                    <Typography>Qty</Typography>
                  </Stack>

                  {/* LOOP THROUGH THE ITEMS ON THE CART AND DISPLAY THEM */}
                  {items?.map((item) => (
                    <Box
                      key={item.item_name}
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        mt: 4,
                        mx: 'auto',
                        width: '50%',
                        position: 'relative',
                      }}
                    >
                      <Typography
                        variant="body1"
                        sx={{ fontWeight: 600, textTransform: 'capitalize' }}
                      >
                        {item.item_name}
                      </Typography>
                      <Typography
                        variant="body1"
                        sx={{ fontWeight: 600, textTransform: 'capitalize' }}
                      >
                        {item.qty}
                      </Typography>

                      <Box sx={inputBox}>
                        <input
                          name={item.item_code}
                          type="number"
                          value={props.values[item.item_code]}
                          onChange={props.handleChange}
                        />
                      </Box>
                    </Box>
                  ))}
                </Box>
              </Grid>

              {/* SELECT INPUT TO SELECT TABLES */}

              <Grid item xs={8} sx={{ mx: 'auto' }}>
                <Typography
                  sx={{
                    textAlign: 'left',
                    color: '#344054',
                    marginBottom: '6px',
                  }}
                >
                  Select Avaliable Tab
                </Typography>
                <Select name="table" label="Choose a table" item={freeTables} />
              </Grid>

              {/* SUBMIT BUTTON */}
              <Grid item xs={6} marginTop={10} sx={{ mx: 'auto' }}>
                {isLoading ? (
                  <CircularProgress />
                ) : (
                  <Button
                    type="submit"
                    variant="contained"
                    sx={{ borderRadius: 2 }}
                  >
                    Split Table
                  </Button>
                )}
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </Box>
  );
};

export default SplitTableForm;
